import { defineAction } from '~/prix'
import { pointOfInterestObject } from '../pointOfInterestObject'
import pointOfInterestListAction from './pointOfInterestList.action.json' assert { type: 'json' }
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'

export const pointOfInterestExpression = expression(pointOfInterestObject.shape)

const pointOfInterestListDefinition = defineAction({
  ...pointOfInterestListAction,
  input: z.object({
    filter: pointOfInterestExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      code: 'Código',
      title: 'Título',
      type: 'Tipo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(pointOfInterestObject),
    count: z.number(),
  }),
})

export default pointOfInterestListDefinition
